<app-loading [exibir]="carregando"></app-loading>
<div class="space">
  <!-- <app-barra-consulta *ngIf="!carregando" visible="false" [listagemComFiltros]="getListagemComFiltros()"
    (atualizando)="atualizar($event)" (inserindo)="novo($event)" (definirFiltro)="definirFiltragem()"
    [exibirNovo]="false" [detalhe]="detalhe">
  </app-barra-consulta> -->
  <button translate pButton type="button" class="p-button-raised p-button-warning p-button-sm ml-1"
    (click)="showDialog()">
    <i class="fa fa-filter mr-1"></i>{{'vorPCA.filter'}}</button>
  <button translate pButton type="button" class="p-button-raised p-button-secondary p-button-sm ml-1"
    (click)="buscar()">
    <i class="fas fa-search mr-1"></i>{{'vorPCA.buscarDados'}}
  </button>
  <button pButton type="button" class="p-button-outlined p-button-secondary p-button-sm pull-right"
    (click)="exportExcel()">
    <i class="fa fa-download mr-1"></i>Export Excel
  </button>

</div>
<div class="conteudo">

  <div *ngIf="!carregando">

    <div class="container-fluid content">

      <table class="table table-sm table-striped table-hover" id="excel-table">
        <thead class="thead-dark">
          <tr>
            <th>
              INDICADORES
            </th>
            <th class="text-center" *ngFor="let mesRef of meses">
              {{mesRef}}
            </th>
            <!-- <th class="text-center">
              Total
            </th> -->
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let categoria of consultaEstoque.dadosSemiNovos.categorias | slice:0:1">
            <td>
              {{categoria.nome}}
            </td>
            <td class="text-center" *ngFor="let itemPeriodo of categoria.periodo">
              {{itemPeriodo.valor | number: '1.0-0'}}
            </td>
            <td class="text-center" >
              {{total_ano_novo_vendido | number: '1.0-0'}}
            </td>
          </tr>
          <tr *ngFor="let categoria of consultaEstoque.dadosSemiNovos.categorias | slice:1:2">
            <td>
              {{categoria.nome}}
            </td>
            <td class="text-center" *ngFor="let itemPeriodo of categoria.periodo">
              {{itemPeriodo.valor | number: '1.0-0'}}
            </td>
            <td class="text-center" >
              {{total_ano_usado_vendido | number: '1.0-0'}}
            </td>
          </tr>
          <tr *ngFor="let categoria of consultaEstoque.dadosSemiNovos.categorias | slice:2:3">
            <td>
              {{categoria.nome}}
            </td>
            <td class="text-center" *ngFor="let itemPeriodo of categoria.periodo">
              {{itemPeriodo.valor | number: '1.0-0'}}
            </td>
            <td class="text-center" >
              {{total_ano_volvo_selekt | number: '1.0-0'}}
            </td>
          </tr>
          <tr>
            <td>Share usados sobre novos vendidos</td>
            <td class="text-center percentual" *ngFor="let itemPeriodo of percentualUsadosVendidos">
              {{itemPeriodo.valor | percent: '1.0-1'}}
            </td>
            <td class="text-center" >
              {{total_ano_usado_vendido / total_ano_novo_vendido | percent: '1.0-1'}}
            </td>
          </tr>
          <tr>
            <td>Share de elegíveis ao Volvo Selekt sobre usados vendidos</td>
            <td class="text-center percentual" *ngFor="let itemPeriodo of percentualSelektUsadosVendidos">
              {{itemPeriodo.valor | percent: '1.0-1'}}
            </td>
            <td class="text-center" >
              {{total_ano_volvo_selekt / total_ano_usado_vendido | percent: '1.0-1'}}              
            </td>
          </tr>
          <tr *ngFor="let categoria of consultaEstoque.dadosSemiNovos.categorias | slice:3:4">
            <td>
              {{categoria.nome}}
            </td>
            <td class="text-center" *ngFor="let itemPeriodo of categoria.periodo">
              {{itemPeriodo.valor | number: '1.0-0'}}
            </td>
            <td class="text-center" >
              {{total_ano_estoque_usado | number: '1.0-0'}}
            </td>
          </tr>
          <tr *ngFor="let categoria of consultaEstoque.dadosSemiNovos.categorias | slice:4:5">
            <td>
              {{categoria.nome}}
            </td>
            <td class="text-center" *ngFor="let itemPeriodo of categoria.periodo">
              {{itemPeriodo.valor | number: '1.0-0'}}
            </td>
            <td class="text-center" >
              {{total_ano_estoque_volvo_usado | number: '1.0-0'}}
            </td>
          </tr>
          <tr>
            <td>Share usados Volvo no estoque</td>
            <td class="text-center percentual" *ngFor="let itemPeriodo of percentualUsadosEstoque">
              {{itemPeriodo.valor | percent: '1.0-1'}}
            </td>
            <td class="text-center" >
              {{total_ano_estoque_volvo_usado / total_ano_estoque_usado | percent: '1.0-1'}}
            </td>
          </tr>
          <tr>
            <td>Share elegíveis ao Volvo Selekt x Volvo Usados </td>
            <td class="text-center percentual" *ngFor="let itemPeriodo of percentualQualificadosSelekt">
              {{itemPeriodo.valor | percent: '1.0-1'}}
            </td>
            <td class="text-center" >
              {{total_ano_volvo_selekt / total_ano_estoque_volvo_usado| percent: '1.0-1'}}
            </td>
          </tr>
          <tr>
          <tr *ngFor="let categoria of consultaEstoque.dadosSemiNovos.categorias | slice:5:6">
            <td>
              {{categoria.nome}}
            </td>
            <td class="text-center" *ngFor="let itemPeriodo of categoria.periodo">
              {{itemPeriodo.valor | currency: 'BRL'}}
            </td>
            <td class="text-center" >
              {{total_ano_margem_usado / 7 | currency: 'BRL'}}
            </td>
          </tr>
          <tr *ngFor="let categoria of consultaEstoque.dadosSemiNovos.categorias | slice:6:7">
            <td>
              {{categoria.nome}}
            </td>
            <td class="text-center" *ngFor="let itemPeriodo of categoria.periodo">
              {{itemPeriodo.valor | currency: 'BRL'}}
            </td>
            <td class="text-center" >
              {{total_ano_margem_selekt / 7 | currency: 'BRL'}}
            </td>
          </tr>
          <tr *ngFor="let categoria of consultaEstoque.dadosSemiNovos.categorias | slice:7:8">
            <td>
              {{categoria.nome}}
            </td>
            <td class="text-center" *ngFor="let itemPeriodo of categoria.periodo">
              {{itemPeriodo.valor | percent: '1.1-1'}}
            </td>
            <td class="text-center" >
              {{percent_total_ano_margem_usado / 7 | percent: '1.1-1'}}
            </td>
          </tr>
          <tr *ngFor="let categoria of consultaEstoque.dadosSemiNovos.categorias | slice:8:9">
            <td>
              {{categoria.nome}}
            </td>
            <td class="text-center" *ngFor="let itemPeriodo of categoria.periodo">
              {{itemPeriodo.valor | percent: '1.1-1'}}
            </td>
            <td class="text-center" >
              {{percent_total_ano_margem_selekt / 7 | percent: '1.1-1'}}
            </td>
          </tr>
          <tr *ngFor="let categoria of consultaEstoque.dadosSemiNovos.categorias | slice:9:10">
            <td>
              {{categoria.nome}}
            </td>
            <td class="text-center percentual" *ngFor="let itemPeriodo of categoria.periodo">
              {{itemPeriodo.valor | number: '1.0-0'}}
            </td>
            <td class="text-center" >
              {{total_ano_custo_reparacao_selekt / 7 | number: '1.0-0'}}
            </td>
          </tr>
          <tr *ngFor="let categoria of consultaEstoque.dadosSemiNovos.categorias | slice:10:11">
            <td>
              {{categoria.nome}}
            </td>
            <td class="text-center percentual" *ngFor="let itemPeriodo of categoria.periodo">
              {{itemPeriodo.valor | number: '1.0-0'}}
            </td>
            <td class="text-center" >
              {{total_ano_tempo_prepara_selekt / 7 | number: '1.0-0'}}
            </td>
          </tr>
          <tr *ngFor="let categoria of consultaEstoque.dadosSemiNovos.categorias | slice:11:12">
            <td>
              {{categoria.nome}}
            </td>
            <td class="text-center percentual" *ngFor="let itemPeriodo of categoria.periodo">
              {{itemPeriodo.valor | number: '1.0-0'}}
            </td>
            <td class="text-center" >
              {{total_ano_tempo_estoque_seminovo / 7 | number: '1.0-0'}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<ng-container>
  <p-dialog class="top-dialog" [style]="{width: '25vw'}" [(visible)]="display" [modal]="true" [draggable]="true"
    [resizable]="false">
    <ng-template pTemplate="header">
      <h5 translate class="modal-title">{{'rmpv.analisePassagem.filtros.definirFiltros'}}</h5>
    </ng-template>
    <ng-template pTemplate="body">
      <div class="container striped-rows">
        <div class="row ptb5">
          <div translate class="col col-4">
            Mercado
          </div>
          <!-- <div class="col col-8">
              <ng-container>
                <p-dropdown appendTo="body"
                  placeholder="{{'rmpv.analisePassagem.filtros.dealerPlaceHolder'  | translate }}" [options]="dealers"
                  formControlName="dealer" optionLabel="descricao" optionValue="id" [style]="{'minWidth':'100%'}">
                </p-dropdown>
              </ng-container>
            </div> -->
          <div class="col col-8">
            <select class="form-control form-control-sm" [(ngModel)]="filtros.mercado">
              <option translate disabled [value]="undefined">{{'rmpv.relatorioAnaliseGeral.filtros.mercadoPlaceHolder'}}
              </option>
              <option *ngFor="let item of mercados" [value]="item.id">{{item.descricao}}</option>
            </select>
          </div>
        </div>
        <div class="row ptb5">
          <div translate class="col col-4">
            Grupo Economicos
          </div>
          <div class="col col-8">
            <select class="form-control form-control-sm" [(ngModel)]="filtros.grupo_economico"
              (change)="preencherDealers()">
              <option translate disabled [value]="undefined">
                {{'rmpv.relatorioAnaliseGeral.filtros.grupoEconomicoPlaceHolder'}}
              </option>
              <option *ngFor="let item of gruposEconomicos" [value]="item.id">{{item.descricao}}</option>
            </select>
          </div>
        </div>
        <div class="row ptb5">
          <div translate class="col col-4">
            Regiao
          </div>
          <div class="col col-8">
            <select class="form-control form-control-sm" [(ngModel)]="filtros.regiao">
              <option translate disabled [value]="undefined">{{'rmpv.relatorioAnaliseGeral.filtros.regiaoPlaceHolder'}}
              </option>
              <option *ngFor="let item of regioes" [value]="item.id">{{item.descricao}}</option>
            </select>
          </div>
        </div>
        <div class="row ptb5">
          <div translate class="col col-4">
            Dealers
          </div>
          <div class="col col-8">
            <select class="form-control form-control-sm" [(ngModel)]="filtros.dealers">
              <option translate disabled [value]="undefined">{{'rmpv.relatorioAnaliseGeral.filtros.dealerPlaceHolder'}}
              </option>
              <option *ngFor="let item of dealers" [value]="item.id">{{item.descricao}}</option>
            </select>
          </div>
        </div>
        <div class="row ptb5">
          <div translate class="col col-4">
            {{'rmpv.relatorioAnaliseGeral.filtros.ano'}}
          </div>
          <div class="col col-8">
            <select class="form-control form-control-sm" [(ngModel)]="filtros.anoSelecao">
              <option translate disabled [value]="undefined">{{'rmpv.relatorioAnaliseGeral.filtros.anoPlaceHolder'}}
              </option>
              <option *ngFor="let item of anoSelecao" [value]="item.id">{{item.descricao}}</option>
            </select>
            <!-- <p-dropdown appendTo="body"
              placeholder="{{'rmpv.relatorioAnaliseGeral.filtros.anoPlaceHolder' | translate }}"
              [options]="anoSelecao" optionLabel="descricao" optionValue="id" formControlName="anoSelecao"
              [style]="{'minWidth':'100%'}" styleClass="p-inputtext-sm">
            </p-dropdown> -->
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
      <button type="button" class="btn btn-info mt-1 pull-right" (click)="getAll()">OK</button>
      <button type="button" class="btn btn-outline-secondary mt-1 pull-right mr-1" (click)="cleanFilter()"><i
          class="fa fa-trash" aria-hidden="true"></i></button>
    </ng-template>
  </p-dialog>
</ng-container>
